import React,{useState, useEffect} from 'react';
import './App.css';

import Board from './components/Board';
import StatusBoard from './components/StatusBoard';

import BG from "./components/imgs/bg.jpg";
import personaje from "./components/imgs/personaje.png";
import StatusMessage from './components/StatusMessage';

import { API_URL, SOPAS } from './config/general';

function App() {

  const queryParameters = new URLSearchParams(window.location.search)
  const urldeck = queryParameters.get("book")

  let sopa_book_id = urldeck ? urldeck : 0;

  const appStyle = {
    height: '100vh',
    width: '100vw',
    backgroundImage: `url(${ BG })`
  }

  const [palabrasBoard, setPalabrasBoard] = useState ([]);
  const [sopaActual, setSopaActual] = useState (0);
  const [sopasPool, setSopasPool] = useState([]);

  const handlepalabrasBoard = (palabras) => {
    setPalabrasBoard(palabras);
  };

  const handleRestartButton = () => {
    // console.log("Restart!")
    if (sopaActual < sopasPool.length - 1){
      setSopaActual(sopaActual + 1);
    }
    else{
      setSopaActual(0);
    }
  }

  useEffect(()=> {

    const getSopas = async () => {

      try {
        let response = await fetch(`${API_URL}${SOPAS}/${sopa_book_id}`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        
        let data = await response.json();
        const sopasRandom = data.sort(() => Math.random() -0.5);
        setSopasPool(sopasRandom);
      } catch (error) {
        // Handle the error
        console.error('Error fetching Sopas data:', error.message);
        // You can set an error state or perform other actions as needed
      }
    };

    getSopas();

  }, [sopa_book_id]);

  const setBoard = () => {
    if(palabrasBoard.length > 0){
      return <StatusBoard palabras={ palabrasBoard } instrucciones={ sopasPool[sopaActual].instrucciones }/>
    }
    else{
      return <StatusMessage message={ sopasPool[sopaActual].texto_sopa_completa } buttonText={ sopasPool[sopaActual].texto_boton_siguiente } buttonClick={ handleRestartButton }/>
    }
  }

  const loading = () => (
    <p>Cargando...</p>
  )

  return (
    <div className="App" style={ appStyle }>
        <img src={ personaje } className='img-personaje' alt="Personajes" />
        { sopasPool[sopaActual] ? <Board sopa={ sopasPool[sopaActual] } exportPalabrasBoard={ handlepalabrasBoard }/> : loading() }
        { sopasPool[sopaActual] ? setBoard() : loading() }
    </div>
  );
}

export default App;
